module.exports = __webpack_public_path__ + "img/rounded-cross.06f6e347.svg";